<template><k-dialog v-model="dialog_open" :fullscreen="true" persistent scrollable><k-card>
<k-card-title style="border-bottom:1px solid #999; background-color:#ddd;"><b>Batch Import Items using LLM <span class="pink--text text--darken-3">(BETA)</span></b>
	<k-spacer/>
	<k-btn color="secondary" @click="$emit('cancel_import')"><k-icon small class="mr-2">fas fa-xmark</k-icon>Cancel</k-btn>
</k-card-title>
<k-card-text class="mt-3 k-ai-import-interface-wrapper" style="font-size:16px">
	<div class="d-flex flex-wrap align-center">
		<b class="mr-2">Source files:</b>
		<k-btn v-for="(file) in ai_import_files" :key="file.name" small outlined color="secondary" class="k-tight-btn k-nocaps-btn mr-2" @click="remove_file(file)"><span style="font-weight:normal">{{file.name}}</span><k-icon small class="ml-2">fas fa-circle-minus</k-icon></k-btn>
		<k-btn small color="primary" @click="add_file"><k-icon small class="mr-2">fas fa-plus</k-icon>Add File</k-btn>
	</div>

	<div class="d-flex mt-4">
		<div style="flex:1 1 50%" class="mr-4">
			<div>
				<div class="d-flex align-center">
					<b>Prompt:</b>
					<k-spacer/>
					<div style="width:240px" class="mr-2">
						<v-select v-model="model" :items="model_options" label="Model" dense outlined hide-details></v-select>
					</div>
					<k-btn small color="primary" @click="run_prompt_once_start"><k-icon small class="mr-2">fas fa-person-running</k-icon>Run</k-btn>
				</div>
				<div class="mt-2">
					<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="5"
						v-model="prompt"
					></k-textarea>
				</div>
			</div>

			<div class="mt-4 mb-4 text-center">
				<k-btn-toggle dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" v-model="alt_prompt_showing" mandatory>
					<k-btn small light class="k-tight-btn k-nocaps-btn" value="system_prompt">System Prompt</k-btn>
					<k-btn small light class="k-tight-btn k-nocaps-btn" value="satchelscript_protocol">SatchelScript Protocol</k-btn>
					<k-btn small light class="k-tight-btn k-nocaps-btn" value="extraction_logic">Extraction Logic</k-btn>
					<k-btn small light class="k-tight-btn k-nocaps-btn" value="schema">Output Schema</k-btn>
				</k-btn-toggle>
			</div>

			<div v-show="alt_prompt_showing=='system_prompt'">
				<div class="d-flex align-end">
					<b>System Prompt:</b>
					<k-spacer/>
					<k-btn small color="secondary" @click="use_default_system_prompt">Use Default</k-btn>
				</div>
				<div class="mt-2">
					<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
						v-model="system_prompt"
					></k-textarea>
				</div>
			</div>
			
			<div v-show="alt_prompt_showing=='satchelscript_protocol'">
				<div class="d-flex align-end">
					<b>SatchelScript Protocol:</b>
					<k-spacer/>
					<k-btn small color="secondary" @click="use_default_satchelscript_protocol">Use Default</k-btn>
				</div>
				<div class="mt-2">
					<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
						v-model="satchelscript_protocol"
					></k-textarea>
				</div>
			</div>
			
			<div v-show="alt_prompt_showing=='extraction_logic'">
				<div class="d-flex align-end">
					<b>Extraction Logic:</b>
					<k-spacer/>
					<k-btn small color="secondary" @click="get_extraction_logic_from_file">Upload from File</k-btn>
				</div>
				<div class="mt-2">
					<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
						v-model="extraction_logic"
					></k-textarea>
				</div>
			</div>
			
			<div v-show="alt_prompt_showing=='schema'">
				<div class="d-flex align-end">
					<b>Output Schema:</b>
					<k-spacer/>
					<k-btn small color="secondary" @click="use_default_schema">Use Default</k-btn>
				</div>
				<div class="mt-2">
					<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
						v-model="schema"
					></k-textarea>
				</div>
			</div>
		</div>

		<div style="flex:1 1 50%" class="mr-4">
			<div class="d-flex align-end">
				<b>Last LLM Response:</b>
				<k-spacer/>
				<k-tooltip bottom><template v-slot:activator="{on}">
					<k-btn v-on="on" small icon outlined color="primary" @click="copy_to_clipboard(last_response)" class="mr-2 k-tight-btn k-nocaps-btn" :disabled="!last_response"><k-icon small>fas fa-copy</k-icon></k-btn>
				</template>Copy last response to clipboard</k-tooltip>

				<!-- TODO: add k-text-field to allow user to enter an education_level -->

				<k-btn small color="primary" class="k-tight-btn k-nocaps-btn" @click="add_to_satchel_script">Add To Satchel Script<k-icon small class="ml-2">fas fa-arrow-right</k-icon></k-btn>
			</div>
			<div class="mt-2">
				<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
					v-model="last_response"
				></k-textarea>
			</div>
			<div class="mt-2" v-if="last_usage_metadata">
				<div><b>Last Response Cost:</b> <span v-html="last_response_cost_display"></span></div>
				<div v-if="previous_last_response_cost_display"><b>Previous:</b> <span v-html="previous_last_response_cost_display"></span></div>
				<div v-if="cumulative_response_cost_display" v-html="cumulative_response_cost_display"></div>
			</div>
		</div>

		<div v-if="satchel_script" style="flex:1 1 50%">
			<div class="d-flex align-end">
				<b>Satchel Script:</b>
				<k-spacer/>
				<k-tooltip bottom><template v-slot:activator="{on}">
					<k-btn v-on="on" small icon outlined color="primary" @click="clear_satchel_script" class="mr-2 k-tight-btn k-nocaps-btn" :disabled="!satchel_script"><k-icon small>fas fa-broom-wide</k-icon></k-btn>
				</template>Clear Satchel Script</k-tooltip>
				<k-tooltip bottom><template v-slot:activator="{on}">
					<k-btn v-on="on" small icon outlined color="primary" @click="undo_satchel_script" class="mr-2 k-tight-btn k-nocaps-btn" :disabled="last_satchel_script===null" v-show="next_satchel_script===null"><k-icon small>fas fa-undo</k-icon></k-btn>
				</template>Undo last change to Satchel Script</k-tooltip>
				<k-tooltip bottom><template v-slot:activator="{on}">
					<k-btn v-on="on" small icon outlined color="primary" @click="redo_satchel_script" class="mr-2 k-tight-btn k-nocaps-btn" v-show="next_satchel_script!==null"><k-icon small>fas fa-redo</k-icon></k-btn>
				</template>redo last change to Satchel Script</k-tooltip>
				<k-tooltip bottom><template v-slot:activator="{on}">
					<k-btn v-on="on" small icon outlined color="primary" @click="copy_to_clipboard(satchel_script)" class="mr-2 k-tight-btn k-nocaps-btn" :disabled="!satchel_script"><k-icon small>fas fa-copy</k-icon></k-btn>
				</template>Copy Satchel Script to clipboard</k-tooltip>
				<k-btn small color="primary" @click="$emit('paste_contents', satchel_script)" class="ml-2 k-tight-btn k-nocaps-btn" :disabled="!satchel_script"><k-icon small class="mr-2">fas fa-paste</k-icon>Paste to Import</k-btn>
			</div>
			<div class="mt-2">
				<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" auto-grow outlined dense hide-details placeholder="" rows="20"
					v-model="satchel_script"
				></k-textarea>
			</div>
		</div>

	</div>
</k-card-text>
</k-card></k-dialog></template>

<script>
import { mapState, mapGetters } from 'vuex'
// import TemplateComponent from '@/components/TemplateComponent'
import CopyBtn from '../utilities/CopyBtn.vue'

// SEE FOR REFERENCE: ItemImportInterface, ItemCSVImportInterface
export default {
	components: {
		CopyBtn
	},
	props: {
		editor_component: { required: true },
	},
	data() { return {
		dialog_open: true,
		last_satchel_script: null,
		next_satchel_script: null,
		// costs are $ per 1M tokens
		default_model: 'gemini-3-flash-preview',
		available_models: {
			'gemini-2.5-flash-lite': { input_cost:'0.10', cached_input_cost:'0.01', output_cost:'0.40', temperature: 0, },
			// 'gemini-2.5-flash': { input_cost:'0.30', cached_input_cost:'0.03', output_cost:'2.50', temperature: 0, },
			// 'gemini-2.5-pro': { input_cost:'1.25', cached_input_cost:'0.125', output_cost:'10.50', temperature: 0, },
			'gemini-3-flash-preview': { input_cost:'0.50', cached_input_cost:'0.05', output_cost:'3.00', temperature: 0, },
			'gemini-3-pro-preview': { input_cost:'2.00', cached_input_cost:'0.20', output_cost:'12.00', temperature: 0, },
		},

		n_runs: 0,
		total_cost_sum: 0,
		previous_last_response_cost_display: '',

		// TODO: use this for education_level
		education_level: '',

		alt_prompt_showing: 'extraction_logic',

		default_satchelscript_protocol: '',
		default_extraction_logic: '',
		default_system_prompt: '',
		default_schema: '',
	}},
	computed: {
		...mapState(['user_info', 'ai_import_files', 'ai_force_reprocess_files']),
		...mapGetters([]),
		model_options() {
			let arr = []
			for (let model in this.available_models) {
				let val = this.available_models[model]
				arr.push({value: model, text: `${model} (${val.input_cost}/${val.output_cost})`})
			}
			return arr
		},

		// note that some of the below are stored in lst, some are stored in state, and some have default values loaded from files
		model: {
			get() { 
				let s = this.$store.state.lst.ai_import_model 
				if (empty(s) || empty(this.available_models[s])) s = this.default_model
				return s
			},
			set(val) { this.$store.commit('lst_set', ['ai_import_model', val]) }
		},
		prompt: {
			get() { return this.$store.state.lst.ai_import_prompt },
			set(val) { this.$store.commit('lst_set', ['ai_import_prompt', val]) }
		},
		
		system_prompt: {
			get() { 
				let s = this.$store.state.ai_import_system_prompt 
				if (!empty(s)) return s
				else return this.default_system_prompt
			},
			set(val) { 
				this.$store.commit('set', ['ai_import_system_prompt', val]) 
			}
		},
		satchelscript_protocol: {
			get() { 
				let s = this.$store.state.ai_import_satchelscript_protocol 
				if (!empty(s)) return s
				else return this.default_satchelscript_protocol
			},
			set(val) { 
				this.$store.commit('set', ['ai_import_satchelscript_protocol', val]) 
			}
		},
		extraction_logic: {
			get() { 
				let s = this.$store.state.ai_import_extraction_logic 
				if (!empty(s)) return s
				else return this.default_extraction_logic

			},
			set(val) { 
				this.$store.commit('set', ['ai_import_extraction_logic', val]) 
			}
		},
		schema: {
			get() { 
				let s = this.$store.state.ai_import_schema 
				if (!empty(s)) return s
				else return this.default_schema
			},
			set(val) { 
				this.$store.commit('set', ['ai_import_schema', val]) 
			}
		},

		last_response: {
			get() { return this.$store.state.lst.ai_import_last_response },
			set(val) { this.$store.commit('lst_set', ['ai_import_last_response', val]) }
		},
		last_usage_metadata: {
			get() { return this.$store.state.lst.ai_import_last_usage_metadata },
			set(val) { this.$store.commit('lst_set', ['ai_import_last_usage_metadata', val]) }
		},
		satchel_script: {
			get() { return this.$store.state.lst.ai_import_satchel_script },
			set(val) { this.$store.commit('lst_set', ['ai_import_satchel_script', val]) }
		},

		last_response_cost() {
			let lum = this.last_usage_metadata
			if (empty(lum?.promptTokenCount)) return 0
			let m = this.available_models[lum.modelVersion]
			if (empty(m)) return 0

			// multiply to get dollar amounts
			let new_input_cost = lum.new_input_tokens / 1000000 * m.input_cost
			let cached_input_cost = lum.cached_input_tokens / 1000000 * m.cached_input_cost
			let output_cost = lum.output_tokens / 1000000 * m.output_cost
			let total_cost = new_input_cost + cached_input_cost + output_cost

			// convert to cents
			total_cost = total_cost * 100
			return total_cost
		},
		last_response_cost_display() {
			if (this.last_response_cost == 0) return ''
			let lum = this.last_usage_metadata
			return `<nobr>[${lum.new_input_tokens}/${lum.cached_input_tokens}/${lum.output_tokens}] tokens = ${this.last_response_cost.toFixed(3)}¢</nobr>`
		},
		cumulative_response_cost_display() {
			if (this.n_runs == 0) return ''
			return `<b>Cumulative:</b> ${this.n_runs}: ${this.total_cost_sum.toFixed(3)}¢</nobr>`
		},
	},
	watch: {
	},
	created() {
		vapp.item_ai_import_component = this
	},
	mounted() {
		this.get_default_files()
	},
	methods: {
		async get_default_files() {
			let text
			
			text = await this.get_server_file('custom/system_prompt.md', false)
			if (!text) text = await this.get_server_file('default/default_system_prompt.md')
			this.default_system_prompt = text

			text = await this.get_server_file('custom/satchelscript_encoding_protocol.md', false)
			if (!text) text = await this.get_server_file('default/default_satchelscript_encoding_protocol.md')
			this.default_satchelscript_protocol = text

			text = await this.get_server_file('default/default_extraction_logic.md')
			this.default_extraction_logic = text

			text = await this.get_server_file('custom/schema.json', false)
			if (!text) text = await this.get_server_file('default/default_schema.json')
			this.default_schema = text
		},

		async get_server_file(filename, required = true) {
			let response
			try {
				response = await fetch(`/src/llm_sources/${filename}`)
				if (!response.ok) {
					if (required) console.warn('couldn’t get (1) ' + filename)
					return ''
				}
			} catch(error) {
				if (required) console.warn('couldn’t get (2) ' + filename, error)
				return ''
			}
			try {
				let text = await response.text()
				return text
			} catch(error) {
				console.warn('couldn’t get (3) ' + filename, error)
				return ''
			}
		},

		async add_file() {
			// prompt for file to import
			let file = await U.prompt_promise({
				text: '<p>Use the interface below to specify the file to process.</p>',
				promptType: 'file',
				acceptText: 'Choose File',
				cancelText: 'Cancel'
			})
			if (!file) return

			this.ai_import_files.push(file)
		},

		async remove_file(file) {
			let val = await U.confirm_promise({
				title: 'Are you sure?',
				text: 'Are you sure you want to remove this file?',
				acceptText: 'Remove',
				acceptColor: 'red darken-3',
			})
			if (!val) return
			// user confirmed

			let i = this.ai_import_files.findIndex(x=>x==file)
			if (i > -1) this.ai_import_files.splice(i, 1)

			// when we remove a file, force reprocessing of files the next time we run. this way, a user can force reprocessing by removing, then readding the same file
			this.$store.commit('set', ['ai_force_reprocess_files', true])
		},

		copy_to_clipboard(s) {
			U.copy_to_clipboard(s)
			this.$inform('Copied!')
		},

		clear_satchel_script() {
			this.last_satchel_script = this.satchel_script
			this.next_satchel_script = null
			this.satchel_script = ''
		},

		add_to_satchel_script() {
			this.last_satchel_script = this.satchel_script
			this.next_satchel_script = null
			if (!empty(this.satchel_script)) {
				this.satchel_script = this.satchel_script.trim() + `\n\n`
			}

			// TODO: allow user to specify an education_level; if specified, run code here to add the satchelscript [09-12] for educationLevel to each CFItem line
			if (!empty(this.education_level)) {
				this.add_education_level()
			}

			this.satchel_script += this.last_response.trim()
			this.$inform('Added to Satchel Script')
		},

		add_education_level() {
			// TODO: add education_level to each ** line
		},	

		undo_satchel_script() {
			this.next_satchel_script = this.satchel_script
			this.satchel_script = this.last_satchel_script
			this.last_satchel_script = null
		},

		redo_satchel_script() {
			this.last_satchel_script = this.satchel_script
			this.satchel_script = this.next_satchel_script
			this.next_satchel_script = null
		},

		use_default_system_prompt() {
			this.system_prompt = ''
		},

		use_default_satchelscript_protocol() {
			this.satchelscript_protocol = ''
		},

		use_default_schema() {
			this.schema = ''
		},

		async get_extraction_logic_from_file() {
			let file = await U.prompt_promise({
				text: '<p>Use the file upload interface below to specify the Extraction Logic file, which must be of type “.md”.</p>',
				promptType: 'file',
				acceptText: 'Upload File',
				cancelText: 'Cancel'
			})
			if (!file) return

			// get file contents
			let file_contents = await this.read_file_promise(file)

			if (!file_contents) {
				this.$alert('The file could not be processed.')
				return
			}

			this.extraction_logic = file_contents
		},

		read_file_promise(file) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader()
				reader.onload = e => {
					resolve(e.target.result)
				}
				reader.onerror = e => {
					console.error('reader error:', e)
					reject()
				}
				reader.readAsText(file)
			})
		},

		run_prompt_once_start() {
			// reset the last_response, then actually run the prompt
			this.last_response = ''
			setTimeout(x=>{
				this.run_prompt()
			}, 50)
		},

		async run_prompt() {
			// make sure schema is valid json
			let schema
			if (!empty(this.schema)) {
				try {
					schema = JSON.parse(this.schema)
				} catch(e) {
					console.error('schema parse error', e)
					this.$alert('Schema could not be parsed.')
					return
				}
			}

			let model_data = this.available_models[this.model]
			
			let payload = {
				prompt: this.prompt,
				model: this.model,
				// we'd like to use temperature 0, but Google says to stick with temperature = 1 for Gemini 3... After finding a lot of variance in responses Nick is trying temperature 0
				temperature: model_data.temperature,
				force_reprocess_files: this.ai_force_reprocess_files,
			}
			let override_options
			if (!empty(this.system_prompt)) {
				payload.system_prompt = this.system_prompt
				// add the satchelscript_protocol and extraction_logic to the system_prompt
				payload.system_prompt = payload.system_prompt.replace(/(<satchelscript_protocol>)(<\/satchelscript_protocol>)/, `$1\n${this.satchelscript_protocol}\n$2`)
				payload.system_prompt = payload.system_prompt.replace(/(<extraction_logic>)(<\/extraction_logic>)/, `$1\n${this.extraction_logic}\n$2`)
				
				//Attempting to rule out any variance/drift in prompts
				//console.log('FINAL SYSTEM PROMPT', payload instanceof FormData ? payload.get('system_prompt') : payload.system_prompt)

			}
			if (!empty(schema)) {
				payload.schema = JSON.stringify(schema)
			}
			if (this.ai_import_files.length > 0) {
				let fd = new FormData()
				for (let i = 0; i < this.ai_import_files.length; ++i) {
					fd.append(`file${i+1}`, this.ai_import_files[i])
				}
				for (let key in payload) {
					fd.append(key, payload[key])
				}
				payload = fd
				override_options = {contentType: false, processData: false}
			}
			// console.warn(payload); return;

			// record previous_last_response_cost_display before we run the ajax call, but don't update it until we finish
			let previous_last_response_cost_display = this.last_response_cost_display

			U.loading_start()
			let result = await this.run_prompt_ajax(payload, override_options)
			U.loading_stop()

			if (!result || result.status != 'ok') {
				this.$inform('Error')
				this.last_response = result.status
				return
			}
			console.log('full gemini response', result)

			// do calculations for cached tokens, then store
			if (result.force_cache_update) {
				result.usage_metadata.cached_input_tokens = 0
			} else {
				result.usage_metadata.cached_input_tokens = result.usage_metadata.cachedContentTokenCount ?? 0
			}
			result.usage_metadata.new_input_tokens = result.usage_metadata.promptTokenCount - result.usage_metadata.cached_input_tokens
			result.usage_metadata.output_tokens = result.usage_metadata.candidatesTokenCount
			this.last_usage_metadata = result.usage_metadata
			this.previous_last_response_cost_display = previous_last_response_cost_display

			if (empty(result.response)) this.last_response = 'NO RESPONSE'
			else this.last_response = result.response

			++this.n_runs
			this.total_cost_sum += this.last_response_cost

			// don't force_reprocess_files next time, unless the user edits the files available
			this.$store.commit('set', ['ai_force_reprocess_files', false])
		},

		run_prompt_ajax(payload, override_options) {
			return new Promise((resolve, reject) => {
				try {
					U.ajax('gemini_query', payload, result=>{
						resolve(result)
					}, override_options)
				} catch(e) {
					console.warn('error in gemini_query ajax', e)
					resolve(false)
				}
			})
		},	
	}
}

/*
		// default schemas
		default_schema_base: {
			type: 'object',
			properties: {
				'output': {
					type: 'string',
				}
			},
			required: ['output'],
			additionalProperties: false
		},
		default_schema_array: {
			type: 'object',
			properties: {
				'output': {
					type: 'array',
					items: { 
						type: 'string',
					},
				}
			},
			required: ['output'],
			additionalProperties: false
		},
		default_schema_structured_array: {
			type: 'object',
			properties: {
				'output': {
					type: 'array',
					items: { 
						type: 'object',
						properties: {
							term: { type: 'string' },
							definition: { type: 'string' },
						},
						required: ['term', 'definition'],
						additionalProperties: false
					},
					minItems: 4,
					maxItems: 8,
					description: `An array of 4-8 objects.`
				}
			},
			required: ['output'],
			additionalProperties: false
		},
*/
</script>

<style lang="scss">

.k-ai-import-interface-wrapper {
	.k-case-item-importer-raw-text-area {
		textarea {
			max-height:calc(100vh - 180px);
			overflow: auto !important;
			font-family: monospace;
			font-size: 12px;
			line-height: 15px !important;
		}
	}
}

</style>